module.exports = __webpack_public_path__ + "static/media/HC2.418038d5.jpg";